var React = require('react');

function IconArrowUpSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M501.2 224.6l-153.8 271h103.2v277.7h103V495.6h101.5z"}));
}

IconArrowUpSolid.displayName = "IconArrowUpSolid";

IconArrowUpSolid.defaultProps = {"viewBox":"0 0 1000.6 1000.7"};

module.exports = IconArrowUpSolid;

IconArrowUpSolid.default = IconArrowUpSolid;
